import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "TitleBlock CampaignEditorRow" }
const _hoisted_2 = {
  key: 0,
  class: "CampaignReadinessIcon CampaignReadinessIconWarning lnr-shield-alert",
  title: "Campaign is not set up correctly!"
}
const _hoisted_3 = {
  key: 1,
  class: "CampaignReadinessIcon CampaignReadinessIconSuccess lnr-shield-check",
  title: "Campaign is set up correctly!"
}
const _hoisted_4 = { class: "CampaignEditorInfoText" }
const _hoisted_5 = { class: "CampaignEditorIssueSentencesList" }
const _hoisted_6 = { class: "CampaignEditorInfoRow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LoadingWrapper, {
        classes: ['CampaignReadinessIconWrapper'],
        isLoading: _ctx.isCampaignReadinessInfoLoading
      }, {
        default: _withCtx(() => [
          (_ctx.isCampaignInvalid)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : (_ctx.isCampaignValid)
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["isLoading"]),
      _createVNode(_component_LoadingWrapper, {
        classes: ['CampaignEditorTitle'],
        isLoading: _ctx.isPrimaryDataLoading
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.latestSavedName), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["isLoading"])
    ]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorInfoBoxDefault',
			{ 'CampaignEditorInfoBox': !_ctx.isCampaignReadinessInfoLoading && (_ctx.isCampaignInvalid || _ctx.isCampaignValid) },
			{ 'CampaignEditorInfoWarning': !_ctx.isCampaignReadinessInfoLoading && _ctx.isCampaignInvalid },
			{ 'CampaignEditorInfoSuccess': !_ctx.isCampaignReadinessInfoLoading && _ctx.isCampaignValid }
		],
      isLoading: _ctx.isCampaignReadinessInfoLoading
    }, {
      default: _withCtx(() => [
        (_ctx.isCampaignInvalid)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "CampaignEditorInfoIcon lnr-info" }, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("div", null, " The campaign cannot be considered as ready / working properly for these reasons: ", -1 /* CACHED */)),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignIssuesAsSentences, (sentence) => {
                    return (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(sentence), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.isCampaignValid)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "CampaignEditorInfoIcon lnr-checkmark-circle" }, null, -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "CampaignEditorInfoText" }, " The campaign is successfully configured. ", -1 /* CACHED */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["classes", "isLoading"])
  ], 64 /* STABLE_FRAGMENT */))
}